export default __webpack_public_path__ + "static/media/coordinadora.584d07d4.webp";